<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>洗车点管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result :show-pager-on-one-page="false" :loading="tableLoading">
      <div slot="action"></div>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="picture" align="center" label="洗车点图片">
          <template slot-scope="scope">
            <div class="wrap-picture-style">
              <img :src="scope.row.picture" alt="" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" align="center" label="洗车点名称"> </el-table-column>

        <el-table-column prop="address" align="center" label="洗车点地址"> </el-table-column>

        <el-table-column prop="mobile" align="center" label="联系电话"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carWashId: "",
      tableLoading: false,
      tableData: [],
    };
  },
  mounted() {
    this.carWashId = this.$route.params.carWashId;
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/carwash/list?carWashId=" + this.carWashId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 编辑条目数据
     * @param id
     */
    editItem(id) {
      this.$router.push({
        name: "modifyCarWashCentre",
        query: {
          id: id,
        },
      });
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/carwash/delete?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .wrap-picture-style {
    width: 100px;
    height: 60px;
    position: relative;
    overflow: hidden;
    margin: auto;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>
